import { TTime, TIME_OF_DAY } from '../components/Calendar/ModalSchedulePost/index'

export const transformEnglishTimeToGeneral24Time = ({ hours, minutes, timeOfDay }: TTime) => {
  const hoursInt = Number.parseInt(hours)
  if (timeOfDay === TIME_OF_DAY.PM) {
    if (hoursInt === 12) {
      return `${hours}:${minutes}`
    } else {
      const hoursInGeneralTime = 12 + hoursInt
      return `${hoursInGeneralTime}:${minutes}`
    }
  } else {
    if (hoursInt === 12) {
      return `00:${minutes}`
    } else {
      if (hoursInt > 9) {
        return `${hoursInt}:${minutes}`
      } else {
        return `0${hoursInt}:${minutes}`
      }
    }
  }
}

export const generateTimeInterval = (interval:number)=>{
  const times = [];
  let tt = 0; 
  const ap = ['AM', 'PM'];

  for (var i=0;tt<24*60; i++) {
    var hh = Math.floor(tt/60);
    var mm = (tt%60);
    const hours_12 = ("0" + (hh%12)).slice(-2) + ':' + ("0" + mm).slice(-2) + (ap[Math.floor(hh/12)]);
    const hours_24 = ("0" + (hh)).slice(-2) + ':' + ("0" + mm).slice(-2)+':'+"00";
    tt = tt + interval;
    times[i] = {hours_12,hours_24}
  }
  return times;
}
